import { HttpApiRequestOptions, HttpRequestData } from '@recruitee/http';

export abstract class IntegrationsHttpRequestData extends HttpRequestData {}

export interface IntegrationHttpApiRequestOptions extends HttpApiRequestOptions {
  context?: string;
}

export interface VideoInterview {
  joinUrl: string;
}
